import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from 'store2';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object,
		store: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/training/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{row.number}/{row.year}</a>;
		};
		const rendererFiles = (val, row) => {
			const files = row.files.map(file => {
				const tooltip = <Tooltip id="file">{file.title}</Tooltip>
				return (
					<OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
						<a style={{color:'#000'}} href={'/file/download/' + file.id}>
							<i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip" />
						</a>
					</OverlayTrigger>
				)
			});
			return <div>
				{files}
			</div>
		};

		this.columnModel = [
			{
				name: 'number',
				title: 'Protokol',
				field: 'number',
				width: 90,
				renderer: rendererLink
			},
			{
				name: 'cTitle',
				title: 'Firma / Řidič',
				renderer: (val, row) => {
					if (row.e && row.drivers && row.drivers[0]) {
            const name = row.drivers[0].name + ' ' + row.drivers[0].surname
            const cTitle = row.drivers[0].cTitle;
						return name + (cTitle ? (' / ' + cTitle) : '');
					}
					else {
						return row.cTitle;
					}
				}
			},
			{
				name: 'date_from',
				title: 'Datum',
				field: 'date_from',
				width: 150,
				renderer: (val, row) => {
					if (row.date_to == row.date_from || !row.date_to) {
						return Renderers.Date(row.date_from);
					}
					else {
						return Renderers.Date(row.date_from) + ' - ' + Renderers.Date(row.date_to);
					}
				}
			},
			{
				name: 'valid_to',
				title: 'Platnost do',
				field: 'valid_to',
				renderer: (val, row) => {
					if (row.e && row.e_status == 1) {
						return ''
					}
					else {
						return Renderers.Date(val);
					}
				}
			},
			{
				name: 'type',
				title: 'Druh',
				field: 'type',
        width: 150,
        style: {whiteSpace: 'nowrap'},
				renderer: (val) => {
				  const style = {
            width: 150,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          };
				  return <div style={style}>{Renderers.DbInfo.bind(DbInfo.TrainingType(context.store))(val)}</div>
        }
			},
			{
				name: 'e',
				title: 'E',
				width: 40,
				align:'center',
				field: 'e',
				renderer: Renderers.CheckThin
			},
			{
				name: 'order',
				width: 65,
				title: 'obj.',
				field: 'orderId',
			},
			{
				name: 'e_status',
				title: 'Stav',
				field: 'e_status',
        width: 95,
				renderer: (val, row) => {
          return row.e ? DbInfo.ETrainingStatus.get(val) : null
        }
			},
      {
        name: 'e_praxe_date',
        title: 'Zácv.',
        field: 'e_praxe_date',
        align:'center',
        width: 30,
        renderer: (val, row) => {
          if (row.e && row.e_status == 2) {
            return Renderers.CheckThin(val);
          }
        }
      },
			{
				name: 'users',
				title: 'Účast',
				sortable: false,
				field: 'count',
				align:'center',
				width: 16,
				renderer: (val) => {
					return val ? val : '';
				}
			},
			{
				name: 'files',
				width: 58,
				title: <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip" />,
				sortable:false,
				renderer: rendererFiles
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 50,
				align:'center',
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/training/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil"></i>
						</a>
					);
				}
			}
		];

		const filterSchema = {
			number: { class: FilterInput },
			order: { class: FilterInput },
			cTitle: { class: FilterInput },
			fulltext: { class: SearchInput },
			e: { class: Select, options: DbInfo.YesNo },
            e_praxe_date: { class: Select, options: DbInfo.YesNo },
			type: { class: Select, options: DbInfo.TrainingType(context.store) },
			e_status: { class: Select, options: DbInfo.ETrainingStatus },
			date_from: { class: DateRange },
			date_to: { class: DateRange },
			valid_to: { class: DateRange },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
        const sessionState = store.session.get('dg-training');
        // default
        let filter = {};
        // session
        if (sessionState && sessionState.filter) {
            filter = sessionState.filter;
        }
        this.defaultFilter = filter;
        this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'id', 'direction': 'desc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('training.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('training.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('training', row.title, row);
	}

    handleNewClick(e) {
        e.preventDefault();
        this.props.newTab();
    }

	render() {

		const buttons = <Button href="/training/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nové školení
		</Button>;

        return (
			<Datagrid
				ref="datagrid"
				id="training"
				api="training.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Training/List.js